<template>
  <div ref="inputbox">
    <div class="sr__input" :class="{'sr__input--invalid': !this.valid}">
      <b-form-radio-group
        v-model="value"
        class="sr__radio-group"
        :disabled="disable"
      >
        <b-form-radio
          v-for="(option, oindex) in options"
          :key="oindex"
          :value="option.value"
          class="sr__value"
        >
          {{option.title}}
        </b-form-radio>
      </b-form-radio-group>
    </div>

    <b-form-invalid-feedback :state="valid">
      {{invalidMsg}}
    </b-form-invalid-feedback>
  </div>
</template>

<script>
export default {
  name: 'InputRadioItem',
  props: {
    field: Object,
    disable: Boolean
  },
  data () {
    return {
      value: 0,
      options: this.field.value.value_options || [],
      toValidate: true,
      valid: true,
      invalidMsg: ''
    }
  },
  watch: {
    value () {
      this.field.value.value[0] = this.value
      this.checkValueIsValid()
    }
  },
  methods: {
    checkValueIsValid (uiNotify = true) {
      if (!this.toValidate) {
        this.valid = true
        this.invalidMsg = ''
        return true
      }

      if (this._isDestroyed) {
        this.valid = true
        this.invalidMsg = ''
        return true
      }

      if (this.value === 0) {
        if (!uiNotify) {
          return false
        }

        this.valid = false
        this.invalidMsg = '欄位必填'
      } else {
        this.valid = true
        this.invalidMsg = ''
      }

      return this.valid
    }
  },
  created () {
    this.toValidate = this.field.validates?.presence
    this.value = this.field.value.value[0] || 0
  },
  mounted () {
    var top = this.$refs.inputbox.getBoundingClientRect().top

    if (this.toValidate) {
      this.$store.dispatch('pushValidateInfo', {
        id: this._uid,
        top: () => { return top },
        checkValueIsValid: this.checkValueIsValid
      })
    }
  }
}
</script>
